import { render, staticRenderFns } from "./ActivityFeed.vue?vue&type=template&id=46a20a23&scoped=true"
import script from "./ActivityFeed.vue?vue&type=script&lang=ts"
export * from "./ActivityFeed.vue?vue&type=script&lang=ts"
import style0 from "./ActivityFeed.vue?vue&type=style&index=0&id=46a20a23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a20a23",
  null
  
)

export default component.exports